import React from "react";
import { TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { Typography } from "design_system/src";
import { ReactComponent as Checkmark } from "design_system/src/static/icons/checkmark.svg";

interface RealStateProps {
  vehicle?: TVehicle;
}

const RealState = ({ vehicle }: RealStateProps) => {
  if (!vehicle?.visibleDefects?.length) return null;

  return (
    <div className="m_b_xl">
      <div className="display_flex flex_wrap flex_gap_lg_desktop m_b_sm">
        <Typography
          scale="large"
          weight="600"
        >
          Estado actual de la moto {vehicle?.internalId} - {vehicle?.brand.name} {vehicle?.model.name} {vehicle?.cylindersCapacity}
        </Typography>

        <div className="border_primary_300 border_solid border_1 br_md p_x_md p_y_xxs flex_center">
          <Typography
            scale="xsmall"
            weight="600"
            className="text_primary_300"
          >
            Moto revisada por mecánico certificado
          </Typography>
        </div>
      </div>

      <Typography
        scale="medium"
        weight="400"
        className="m_b_sm"
      >
        Esta unidad ha sido inspeccionada y te contamos sus detalles reales. Son marcas de uso normal que no afectan su funcionamiento.
      </Typography>

      {vehicle?.visibleDefects?.map((item, index) => {
        return (
          <div className="display_flex flex_align_start flex_gap_sm m_b_xs" key={`RealState-${index}`}>
            <Checkmark className="text_primary_300 w_lg" />
            <Typography
              scale="medium"
              weight="400"
              className="m_b_sm"
            >{item}</Typography>
          </div>
        );
      })}
    </div>
  );
};

export default RealState;
